module.exports = __webpack_public_path__ + "img/logo3.55c1d38e.png";